import { render, staticRenderFns } from "./TableRoles.vue?vue&type=template&id=d77fa4fe"
import script from "./TableRoles.vue?vue&type=script&lang=js"
export * from "./TableRoles.vue?vue&type=script&lang=js"
import style0 from "./TableRoles.vue?vue&type=style&index=0&id=d77fa4fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports